import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Disable React Error Overlay in production
if (process.env.REACT_APP_DISABLE_ERROR_OVERLAY === 'true') {
  const noop = () => {};
  if (typeof window !== 'undefined') {
    (window as any).__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = {
      isSupportedErrorBoundary: noop,
      storeErrorBoundaryData: noop,
      reportRuntimeError: noop,
      reportBuildError: noop,
      clearRuntimeErrors: noop
    };
  }
}

// Body'nin scroll yapabilmesini sağla
document.body.style.overflow = 'auto';
document.body.style.height = 'auto';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
